module.exports = __webpack_public_path__ + "static/img/bx_line.9f8cad36.png";